<div class="sc" role="radiogroup" [attr.aria-label]="ariaLabel() || null" [attr.data-if-glow]="disabled() ? null : ''">
  @for (option of options(); track option.value; let i = $index) {
    <button
      #optionButton
      type="button"
      role="radio"
      class="sc-option"
      data-if-glow
      [class.sc-option--active]="option.value === value()"
      [class.sc-option--disabled]="isOptionDisabled(option)"
      [attr.aria-checked]="option.value === value()"
      [attr.aria-disabled]="isOptionDisabled(option) ? 'true' : null"
      [attr.aria-describedby]="reasonId(option, i)"
      [attr.tabindex]="tabIndexFor(option)"
      [disabled]="disabled()"
      [appTooltip]="option.disabledReason || ''"
      [tooltipDisabled]="!option.disabledReason"
      (click)="select(option.value)"
      (keydown)="onKeydown($event, i)"
    >
      <span class="sc-option__label" [attr.data-label]="option.label">{{ option.label }}</span>
    </button>
    @if (option.disabledReason) {
      <span class="sc-reason" [id]="reasonId(option, i)">{{ option.disabledReason }}</span>
    }
  }
</div>
